import { useEffect, useCallback } from 'react';
import { useMapName } from 'entities/map';
import { useApplicationOperations } from 'entities/application';
import { useLoadMapLibraries } from './useLoadMapLibraries';
import { useMapContext } from 'entities/map';
import { useMapOperations } from 'entities/map';

import { RefObject } from 'react';
import { Props as MapProps } from '../index';

type TUseInitMap = (
  containerRef: RefObject<HTMLDivElement>,
  onInitializedMap: MapProps['onInitializedMap']
) => void;


export const useInitMap: TUseInitMap = (containerRef, onInitializedMap) => {
  const { initMap } = useMapContext();
  const mapName = useMapName();
  const loadMapLibraries = useLoadMapLibraries();
  const { setErrorNotice } = useApplicationOperations();
  const { setInitializedMap } = useMapOperations();

  const initMapHandler = useCallback(async () => {
    try {
      await loadMapLibraries();
      const map = initMap(mapName, containerRef);
      setInitializedMap(true);
      if (onInitializedMap && map) {
        onInitializedMap(map);
      }
    } catch (e) {
      setErrorNotice({ title: 'Error loading the map' });
    }
  }, [
    loadMapLibraries,
    initMap,
    containerRef,
    setErrorNotice,
    onInitializedMap,
    setInitializedMap,
    mapName
  ]);

  useEffect(() => {
    initMapHandler();
    // eslint-disable-next-line
  }, []);
};
